import React, { useState } from 'react';
import { Eye, Save, X } from 'lucide-react';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import PageHeader from './PageHeader';
import './GatherFormPage.css';

export default function GatherFormPage({
  title,
  subtitle,
  backLabel,
  onBack,
  children,
  preview,
  previewTitle = '即時預覽',
  primaryLabel,
  savingLabel,
  onPrimary,
  draftStatus = '',
  onSaveDraft = null,
  saveDraftLabel = '儲存',
  isSaving = false,
  isLoading = false
}) {
  const isDesktop = useIsDesktop();
  const [showMobilePreview, setShowMobilePreview] = useState(false);

  if (isLoading) {
    return (
      <div className="gather-form-loading" role="status" aria-label="載入表單">
        <span className="gather-form-spinner" />
      </div>
    );
  }

  const primaryButton = (
    <button
      type="button"
      className="gather-form-primary"
      onClick={onPrimary}
      disabled={isSaving}
    >
      {isSaving ? savingLabel : primaryLabel}
    </button>
  );

  const saveDraftButton = onSaveDraft ? (
    <button type="button" className="gather-form-secondary gather-form-save-draft" onClick={onSaveDraft} disabled={isSaving}>
      <Save size={17} /> {saveDraftLabel}
    </button>
  ) : null;

  const mobilePreviewButton = (
    <button type="button" className="gather-form-header-preview" onClick={() => setShowMobilePreview(true)}>
      <Eye size={17} /> 預覽
    </button>
  );

  return (
    <div className={`gather-form-page${onSaveDraft ? ' gather-form-page--draft' : ''}`}>
      <PageHeader title={title} subtitle={subtitle} backLabel={backLabel} onBack={onBack} rightAction={!isDesktop && onSaveDraft ? mobilePreviewButton : null} />

      <main className="gather-form-main">
        <div className="gather-form-column">{children}</div>
        {isDesktop && (
          <aside className="gather-form-preview-column" aria-label={previewTitle}>
            <div className="gather-form-preview-sticky">
              <div className="gather-form-preview-heading">
                <Eye size={18} />
                <div>
                  <h2>{previewTitle}</h2>
                  <p>內容會隨填寫即時更新</p>
                </div>
              </div>
              <div className="gather-form-preview-content">{preview}</div>
              {draftStatus && <p className="gather-form-draft-status" role="status">{draftStatus}</p>}
              {saveDraftButton}
              {primaryButton}
            </div>
          </aside>
        )}
      </main>

      {!isDesktop && (
        <div className="gather-form-mobile-actions">
          {draftStatus && <p className="gather-form-mobile-draft-status" role="status">{draftStatus}</p>}
          {saveDraftButton || <button type="button" className="gather-form-secondary" onClick={() => setShowMobilePreview(true)}><Eye size={18} /> 預覽</button>}
          {primaryButton}
        </div>
      )}

      {!isDesktop && showMobilePreview && (
        <div className="gather-form-mobile-preview" role="dialog" aria-modal="true" aria-label={previewTitle}>
          <div className="gather-form-mobile-preview-header">
            <div>
              <h2>{previewTitle}</h2>
              <p>確認內容後即可發布或儲存</p>
            </div>
            <button type="button" aria-label="關閉預覽" onClick={() => setShowMobilePreview(false)}>
              <X size={22} />
            </button>
          </div>
          <div className="gather-form-mobile-preview-content">{preview}</div>
        </div>
      )}
    </div>
  );
}
